import { AttributeTypes } from '@iddataweb/idw-common-ui/enums';
import { getIDOptionValidationTextByAttributeType } from '@utils/id-options-util';
import { useSelector } from 'react-redux';
import { getLanguageContent } from '@redux/selectors/language-selectors';
import { SelectOption } from '@iddataweb/idw-common-ui/types';

type IDDisclaimerTextProps = {
    idOptions: Array<SelectOption & { id: string; uuid?: string }>;
    attributeType: AttributeTypes;
};

export const IDDisclaimerText = (props: IDDisclaimerTextProps) => {
    const { idOptions, attributeType } = props;

	const uniqueOptions = idOptions.map((idOption) => {
		idOption.uuid =
			Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
		return idOption;
	});

    const content = useSelector(getLanguageContent);

	return (
		<div className="dlpp-disclaimer">
			<p>{content.form.pickerInput.idType}</p>
			<p>{content.form.pickerInput.idTypeExplanation}</p>
			<ul>
				{uniqueOptions.map((idOption, index) => {
					return (
						<p key={index}>
							<li key={idOption.uuid}>
								{getIDOptionValidationTextByAttributeType(content, idOption.value, attributeType)}
							</li>
						</p>
					);
				})}
			</ul>
		</div>
	);
}
